import { Injectable } from '@angular/core';
import { Apollo, gql } from 'apollo-angular-boost';
import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LosApplicationV2Model } from '../models/los-application-v2.model';

@Injectable({
  providedIn: 'root'
})
export class LosApplicationsV2Service {

  private query = gql`
  query application($where: ApplicationFilter!) {
    application(where:$where) {
      _id
      name
      description
      url
      icon
      version
      port
      host
      systemId
      system {
        _id
        name
        description
        active
        deletedAt
      }
      applicationTypeId
      applicationType {
        _id
        name
        code
        description
        active
        createdAt
        deletedAt
      }
      menus {
        _id
        name
        path
        icon
        description
        order
        applicationId
        menuId
        isPublic
        childs {
          _id
          name
          path
          icon
          description
          order
          applicationId
          menuId
          isPublic
          active
          deletedAt
        }
        active
        deletedAt
      }
      active
      deletedAt
    }
  }
  `;

  constructor(
    private apollo: Apollo
  ) { }

  get(id: string): Observable<LosApplicationV2Model> {
    return this.apollo.use('public').query<any>({
      query: this.query,
      variables: {
        where: {
          _id: id
        }
      }
    }).pipe(map(response => {
      return _.cloneDeep(response.data.application as LosApplicationV2Model);
    }));
  }
}
